import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { getCurrentBoardId } from '../../../../element/selectors/currentBoardSelector';
import {
    getCurrentUserLastViewedBoardId,
    getCurrentUserQuickNotesRootBoardId,
    getCurrentUserRootBoardId,
} from '../../../../user/currentUserSelector';
import { newNotificationsCountSelector } from '../../../../workspace/header/workspaceToolsHeader/notifications/notificationsUtilSelector';

import { canGiveFeedback, canWrite } from '../../../../../common/permissions/permissionUtil';
import { openSheet } from '../../../structural/sheet/sheetActions';

import Button from '../../../../components/buttons/Button';
import Icon from '../../../../components/icons/Icon';

import { ToolbarListType } from '../../../../workspace/toolbar/toolbarTypes';
import { Link } from '../../../../../node_module_clones/react-router';
import { SheetId } from '../../../structural/sheet/sheetTypes';

import './MobileTabsToolList.scss';

type MobileTabsToolListProps = {
    setDefaultToolbarType: (toolbarType: ToolbarListType) => void;
    permissions: number;
};

const MobileTabsToolList = ({ setDefaultToolbarType, permissions }: MobileTabsToolListProps) => {
    const currentBoardId = useSelector(getCurrentBoardId);

    const rootBoardId = useSelector(getCurrentUserRootBoardId);
    const lastViewedBoardId = useSelector(getCurrentUserLastViewedBoardId);
    const quickNotesBoardId = useSelector(getCurrentUserQuickNotesRootBoardId);

    const dispatch = useDispatch();
    const openQuickAddSheet = () => dispatch(openSheet(SheetId.QuickAddMenu));

    const isCurrentBoardQuickNotes = currentBoardId === quickNotesBoardId;

    const disableAddButton = !canWrite(permissions) && !canGiveFeedback(permissions);

    const newNotificationsCount = useSelector(newNotificationsCountSelector);

    const hasUnseenNotifications = newNotificationsCount > 0;

    const onClickAddButton = () => {
        if (isCurrentBoardQuickNotes) {
            openQuickAddSheet();
            return;
        }

        setDefaultToolbarType(ToolbarListType.CREATE_ELEMENT);
    };

    return (
        <div className="MobileTabsToolList">
            <div className="left">
                <Button
                    id="mobile-more-button"
                    className="mobile-util-button"
                    onClick={() => setDefaultToolbarType(ToolbarListType.MOBILE_UTILS)}
                >
                    {hasUnseenNotifications && <div className="indicator" />}
                    <Icon name="mobile-toolbar-more" />
                </Button>
            </div>

            <div className="center">
                <Link
                    className={classNames('mobile-board-tab', { active: !isCurrentBoardQuickNotes })}
                    to={isCurrentBoardQuickNotes ? `/${lastViewedBoardId}` : `/${rootBoardId}`}
                >
                    Your boards
                </Link>
                <Link
                    className={classNames('mobile-board-tab', { active: isCurrentBoardQuickNotes })}
                    to={`/${quickNotesBoardId}`}
                >
                    Quick notes
                </Link>
            </div>
            <div className="right">
                <Button
                    id="mobile-new-element-button"
                    className="mobile-util-button"
                    onClick={onClickAddButton}
                    disabled={disableAddButton}
                >
                    <Icon name="mobile-toolbar-add-element" />
                </Button>
            </div>
        </div>
    );
};

const memoisedTabsToolList = React.memo(
    MobileTabsToolList,
    (prevProps, nextProps) => prevProps.permissions === nextProps.permissions,
);

export default memoisedTabsToolList;
